import { createMuiTheme } from "@material-ui/core/styles";
import CMS2 from "./CMS2";
//@ts-ignore
export default createMuiTheme(CMS2);